import React from 'react';
import styled from 'styled-components';
import QuestionMark from "../../../assets/images/icon/QuestionMark";

const QueText = (props) => {
return(
    <Container className={"tooltip"} style={props.style}>
        <p>
            {props.text || "You are required to add either a Sample Q&A or a Sample Video."}
        </p>
        <QuestionMark/>
    </Container>
)

}
export default QueText;

const Container = styled.div`
    display: inline-block;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
    p{
        pointer-events: none;
        opacity: 0;    
    }
    &:hover{
        p{
            opacity: 1;    
        }
    }
    p{
        transition: all 0.2s;
        
        transform: translateX(calc(-50% + 8px));
        bottom: 5px;
        display: flex;
        position: absolute;
        z-index: 99999;
        color: #FFF!important;
        text-align: center;
        font-size: 13px!important;
        font-style: normal!important;
        font-weight: 400!important;
        line-height: 18px!important;
        text-transform: capitalize;
        background-color: #4B85FA;
        max-width: 208px!important;
        min-width: 200px;
        padding: 7px 0 8px;
        border-radius: 10px;
        min-height: 50px;
        //width: 100px;
        border-top-color: #4B85FA;
        &::after{
            content: "";
            position: absolute;
            bottom: -12px;
            left: calc(50% - 6px);
            transform: translateX(-50%);
            transform: rotate(180deg);
            border-width:6px;
            border-style: solid;
            border-color: transparent transparent #4B85FA transparent;
            box-shadow: none;
        }
    }
`;